// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Sites\Enums\SiteField
// Generated on: <normalized>

export enum SiteField {
  DB_TABLE = 'vxapp_sites',
  DB_IDENTIFIER = 'siteGUID',
  DOMAIN = 'domain',
  DEVELOPMENT_DOMAIN = 'developmentDomain',
  VXAPP_SUBDOMAIN = 'vxappSubdomain',
  PRIMARY_DOMAIN_GUID = 'primaryDomainGUID',
  DOMAIN_DELETION_STATE = 'domainDeletionState',
  DOMAIN_DELETION_GENERATION = 'domainDeletionGeneration',
  DOMAIN_DELETION_OWNER = 'domainDeletionOwner',
  STATUS = 'status',
  MAINTENANCE_MODE = 'maintenanceMode',
  MAINTENANCE_MESSAGE = 'maintenanceMessage',
  THEME = 'theme',
  CONTACT_EMAIL = 'contactEmail',
  CONTACT_NUMBER = 'contactNumber',
  LOGO_FILE_GUID = 'logoFileGUID',
  FAVICON_FILE_GUID = 'faviconFileGUID',
  TERMS_FILE_GUID = 'termsFileGUID',
  TERMS_URL = 'termsURL',
  CONTACT_FORM_USER_TEMPLATE_GUID = 'contactFormUserTemplateGUID',
  CONTACT_FORM_ADMIN_TEMPLATE_GUID = 'contactFormAdminTemplateGUID',
  CUSTOM_DOMAIN = 'customDomain',
  SETTINGS = 'settings',
  SITE_TYPE = 'siteType',
  PRODUCT_CAROUSEL_GUIDS = 'productCarouselGUIDs',
  FACEBOOK_DATA = 'facebookData',
  INSTAGRAM_DATA = 'instagramData',
  INSTAGRAM_ACCOUNT_GUID = 'instagramAccountGUID',
  GOOGLE_ADS_ID = 'google_ads_id',
  GOOGLE_TAG_MANAGER_ID = 'google_tag_manager_id',
  FACEBOOK_PIXEL_ID = 'facebook_pixel_id',
  TIKTOK_PIXEL_ID = 'tiktok_pixel_id',
}

export const SiteFieldGetEncryptionFields = [] as const;

export const SiteFieldCases = ["vxapp_sites", "siteGUID", "domain", "developmentDomain", "vxappSubdomain", "primaryDomainGUID", "domainDeletionState", "domainDeletionGeneration", "domainDeletionOwner", "status", "maintenanceMode", "maintenanceMessage", "theme", "contactEmail", "contactNumber", "logoFileGUID", "faviconFileGUID", "termsFileGUID", "termsURL", "contactFormUserTemplateGUID", "contactFormAdminTemplateGUID", "customDomain", "settings", "siteType", "productCarouselGUIDs", "facebookData", "instagramData", "instagramAccountGUID", "google_ads_id", "google_tag_manager_id", "facebook_pixel_id", "tiktok_pixel_id"] as const;
